export const SearchableSkuFilters = [
    'countryIds',
    'categoryIds',
    'supplierIds',
    'brandIds',
    'attributeIds',
    'attributeGroupIds',
    'retailerIds',
    'retailerTypeIds',
    'promotionIds',
];
